<template>
  <div>
    <v-data-table
      item-key="id"
      :headers="headers"
      :loading="loading"
      :items="documents"
      :items-per-page="10"
      :disable-sort="$vuetify.breakpoint.smAndDown"
      :footer-props="{ 'items-per-page-text': 'Số Hồ Sơ một trang' }"
      v-bind="this.$attrs"
    >
      <template v-slot:[`footer.page-text`]="items">
        Hồ sơ thứ {{ items.pageStart }} - {{ items.pageStop }} trên tổng {{ items.itemsLength }} Hồ sơ
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const originHeaders = [
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: false
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    sortable: false
  },
  {
    text: 'SBD',
    value: 'examCode',
    align: 'left',
    sortable: false
  },
  {
    text: 'Điểm',
    value: 'value',
    align: 'left',
    sortable: false
  }
]

export default {
  props: {
    documents: Array
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      loading: false,
      headers: originHeaders
    }
  },

  methods: {}
}
/* eslint-enable no-unused-vars */
</script>
